import React from "react";

function Confirm(props: React.PropsWithChildren<{}>) {
    return (
        <div className="confirm">
            <h2>Bestätigung</h2>
            {props.children}
        </div>
    );
}
export default Confirm;
